import { BillingTypes } from "../../../scenes/Students/Billing/types";

export interface AccomplishmentCertificate {
  certificateOf: 'COURSE' | 'PROGRAM';
  completedDate: number;
  courseName: string;
  id: string;
  organizationName: string;
  programCoordinatorNames: string[];
  programName: string;
  studentName: string;
}

export interface StudentStoreStateType {
  courseStatuses: any;
  coursesCompleted: number;
  coursesEnrolled: number;
  coursesInprogress: number;
  joinDate: string;
  lastLogin: string;
  studentEmail: string;
  studentName: string;

  //accomplishment
  myAccomplishment: AccomplishmentStoreType;
  billingNotification: {
    count: 0,
    pendingBills: BillingTypes[]
  }
}
export interface AccomplishmentStoreType {
  course: AccomplishmentCertificate[];
  program: AccomplishmentCertificate[];
  current: Array<any>;
}

export const StudentStoreState: StudentStoreStateType = {
  courseStatuses: [],
  coursesCompleted: 0,
  coursesEnrolled: 0,
  coursesInprogress: 0,
  joinDate: '',
  lastLogin: '',
  studentEmail: '',
  studentName: '',

  myAccomplishment: {
    course: [],
    program: [],
    current: []
  },
  billingNotification: {
    count : 0,
    pendingBills: []
  }
};


